import _ from 'lodash'

export const dataIsEmpty = (data) => _.every(data, (x) => _.isEmpty(x)) // eslint-disable-line import/prefer-default-export
